export type HeaderVariant = "default" | "calendar-uplift";

export const resolveHeaderHeight = ({
  variant = "default",
  wide,
}: {
  variant?: HeaderVariant;
  wide: boolean;
}): string => {
  if (variant === "calendar-uplift") return "56px";
  return wide ? "60px" : "50px";
};
